module.exports = __webpack_public_path__ + "static/media/shop_list.8b085c3a.svg";